import Constants from './Constants'
import NotifyActions from './NotifyActions'

/**
 * NOTE: If itemRootName is present, the calls to get, remove and update change from
 * taking the parent and item to just taking the item. All other arguments shift
 **/
function create( { parentName, itemsName, itemName, itemRootName, actionTypeBase, parentIdKey, humanItemName, isUser, notify = {}, totalKey } ) {

  const STATUS = Constants[`GET_${actionTypeBase}S_STATUS`]
  const GET = Constants[`GET_${actionTypeBase}S`]
  const GET_ONE = Constants[`GET_${actionTypeBase}`]
  const ADD = Constants[`ADD_${actionTypeBase}`]
  const REMOVE = Constants[`REMOVE_${actionTypeBase}`]
  const UPDATE = Constants[`UPDATE_${actionTypeBase}`]

  function list( parent, options ) {
    return function( dispatch, getState, api ) {

      dispatch( { type : STATUS, status : Constants.STATUS_LOADING, statusMessage : null } )
      return api[parentName]( parent )[itemsName]().list( options )
        .then( ( data ) => {
          let total
          if ( totalKey ) {
            total = data[totalKey]
          } else {
            total = data.count != null ? data.count : data.total
          }
          dispatch( {
            type : GET,
            [parentIdKey] : parent.id || parent,
            startIndex : data.offset != null ? data.offset : data.startIndex,
            total,
            perPage : data.limit != null ? data.limit : data.perPage,
            items : data.items,
            search : data.search
          } )
        } )
        .catch( ( x ) => {
          dispatch( NotifyActions.requestError( `Failed to get ${humanItemName}s`, x ) )
          dispatch( { type : STATUS, status : Constants.STATUS_ERROR } )
        } )
    }
  }

  function create( parent, item ) {
    return function( dispatch, getState, api ) {
      return api[parentName]( parent )[itemsName]().create( item )
        .then( ( data ) => {
          console.log( 'create', data )
          dispatch( { type : ADD, item : data } )
          if ( notify.create ) {
            dispatch( NotifyActions.success( `Successfully Created ${humanItemName}`, data.name || data.id ) ) 
          }
        } )
        .catch( ( err ) => {
          dispatch( NotifyActions.requestError( `Failed to Create ${humanItemName}`, err ) )
          return err
        } )
    }
  }

  function add( parent, item, info ) {
    return function( dispatch, getState, api ) {
      return api[parentName]( parent )[itemsName]().add( item, info )
        .then( ( data ) => {
          console.log( 'add', data )
          dispatch( { type : ADD, item : data } )
          if ( notify.add ) {
            dispatch( NotifyActions.success( `Successfully Created ${humanItemName}`, data.name || data.id ) )
          }
        } )
        .catch( ( err ) => {
          dispatch( NotifyActions.requestError( `Failed to Create ${humanItemName}`, err ) )
          return err
        } )
    }
  }

  function get( parent, item, options ) {
    return function( dispatch, getState, api ) {
      let req
      if ( itemRootName ) {
        req = api[itemRootName]( parent ).get( item )
      } else if ( itemName ) {
        req = api[parentName]( parent )[itemName]( item ).get( options )
      } else {
        req = api[parentName]( parent )[itemsName]().get( item, options )
      }
      return req
        .then( ( data ) => { dispatch( { type : GET_ONE, item : data } ) } )
        .catch( ( err ) => { dispatch( NotifyActions.requestError( `Failed to Create ${humanItemName}`, err ) ) } )
    }
  }

  function remove( parent, item ) {
    return function( dispatch, getState, api ) {
      // api[parentName]( parent )[itemsName]().delete( item )
      let req
      if ( itemRootName ) {
        req = api[itemRootName]( parent ).delete( )
      } else if ( itemName ) {
        req = api[parentName]( parent )[itemName]( item ).delete()
      } else {
        req = api[parentName]( parent )[itemsName]().delete( item )
      }
      return req
        .then( ( data ) => {
          dispatch( { type : REMOVE, itemId : typeof item === 'string' ? item : item.id } )
          if ( notify.remove ) {
            dispatch( NotifyActions.success( `Successfully Removed ${humanItemName}`, data.name || data.id ) )
          }
        } )
        .catch( ( err ) => {
          dispatch( NotifyActions.requestError( `Failed to Remove ${humanItemName}`, err ) )
        } )
    }
  }

  function update( parent, item, patchOps, opts ) {
    return function( dispatch, getState, api ) {
      let req
      if ( itemRootName ) {
        req = api[itemRootName]( parent ).update( item, patchOps )
      } else if ( itemName ) {
        req = api[parentName]( parent )[itemName]( item ).update( patchOps )
      } else {
        req = api[parentName]( parent )[itemsName]().update( item, patchOps, opts )
      }
      return req
        .then( ( data ) => {
          dispatch( { type : UPDATE, item : data } )
          if ( notify.update ) {
            dispatch( NotifyActions.success( `Successfully Updated ${humanItemName}`, data.name || data.id ) )
          }
        } )
        .catch( ( err ) => {
          dispatch( NotifyActions.requestError( `Failed to Update ${humanItemName}`, err ) )
          return err
        } )
    }
  }

  return {
    list,
    create : isUser ? null : create,
    get,
    add : isUser ? add : null,
    delete : remove,
    update
  }
}

module.exports = {
  create
}
